import { UserProfileIcon } from "@/components/shared/icons";
import { Avatar, AvatarFallback, AvatarImage, AvatarLoading, View } from "@/components/ui";

export const WorkerAvatar = ({
  src,
  alt = "",
  className = "",
  size = 32,
}: {
  src: string | null;
  alt?: string;
  className?: string;
  size?: number;
}) => {
  return (
    <Avatar
      alt={alt}
      className="overflow-hidden rounded-full"
      style={{ width: size, height: size }}
    >
      <AvatarLoading />
      <AvatarImage
        src={src || undefined}
        className={className}
        style={{ width: size, height: size }}
      />
      <AvatarFallback>
        <View className="bg-background-intermediate">
          <UserProfileIcon className="color-foreground-intermediate" width={size} height={size} />
        </View>
      </AvatarFallback>
    </Avatar>
  );
};
